import React from "react";
import PropTypes from "prop-types";

import vinylIcon from "../../../assets/images/vinyl-record.svg";
import { connect } from "react-redux";
import "../PartyLayout/Votify.css";
import VotifyPartyHeaderTrackInfo from "./VotifyPartyHeaderTrackInfo";

const VotifyPartyHeader = ({ playback, nextTrack }) => (
  <header className="Votify-header">
    <img src={vinylIcon} className="Votify-logo" alt="logo" />
    {playback && playback.item && (
      <VotifyPartyHeaderTrackInfo playback={playback} nextTrack={nextTrack} />
    )}
  </header>
);

VotifyPartyHeader.propTypes = {
  playback: PropTypes.object,
  nextTrack: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    playback: state.playback.playback,
    nextTrack: state.playback.nextTrack,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VotifyPartyHeader);
